export const COMPANIES = ["AB", "LTD"];
